import cn from 'classnames';
import type React from 'react';
import { useMemo, type MouseEvent, type MouseEventHandler } from 'react';
import { Link } from 'react-router-dom';
import { useClientGroupPageRedirect } from '@pages/clients/group-page/helpers.ts';
import { SelectingIdsIconCheckbox } from '@widgets/shared/SelectingIconCheckbox/index';
import { GroupCoaches, Group as IconGroup, Person } from '@shared/assets';
import { usePlatformSettings } from '@shared/hooks/index.ts';
import type { Group } from '@shared/types/common';
import { Card } from '@shared/ui';
import * as st from './styles.module.scss';

const getGroupIcon = (specialType: string | null) => {
  if (specialType === 'coaches') {
    return <GroupCoaches />;
  }
  if (specialType === 'without_group') {
    return <Person />;
  }
  return <IconGroup />;
};

type Props = {
  group: Group;
  linkValue?: string;
  onRedirect?: () => void;
  className?: string;
  onSelecting?: () => void;
};

export const GroupItem: React.FC<Props> = ({
  className,
  onRedirect,
  group,
  onSelecting,
  linkValue = `${group.id}`,
}) => {
  const { is_can_view_other_specialists } = usePlatformSettings();

  const { doSavePageUrl } = useClientGroupPageRedirect();

  const isCanViewGroupEntriesPermission = useMemo(() => {
    return !(group.special_type === 'coaches' && !is_can_view_other_specialists);
  }, [group, is_can_view_other_specialists]);

  const onGroupRedirect: MouseEventHandler<HTMLAnchorElement> = (e: MouseEvent) => {
    if (!isCanViewGroupEntriesPermission) {
      e.preventDefault();
    } else {
      doSavePageUrl();
      onRedirect && onRedirect();
    }
  };

  // const [count, setCount] = useState<number>();
  //
  // useEffect(() => {
  //   setCount((count) => group.users_count);
  // }, [group.users_count]);
  // console.log("group.users_count:", group.users_count);

  return (
    <Card className={cn(st.item, className)}>
      <SelectingIdsIconCheckbox
        onSelect={onSelecting}
        onUnSelect={onSelecting}
        id={group.id}
        name={'groups'}
      />

      <Link className={st.link} to={linkValue} onClick={onGroupRedirect}>
        {typeof group.photo === 'string' ? (
          <img className={st.item__photo} src={group.photo} alt={group.name} />
        ) : (
          <div className={st.item__photo}>{getGroupIcon(group.special_type)}</div>
        )}
        <div className={st.item__name}>{group.name}</div>
        {isCanViewGroupEntriesPermission && (
          <div className={st.item__count}>{group.users_count}</div>
        )}
      </Link>
    </Card>
  );
};

export default GroupItem;
